import * as Types from "../Constants/AllConstants";

export const SmsSendReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.SEND_SMS_REQUEST:
    case Types.SEND_SMS_BULK_REQUEST:
    case Types.SEND_SMS_CSV_REQUEST:
      return { loading: true };
    case Types.SEND_SMS_SUCCESS:
    case Types.SEND_SMS_BULK_SUCCESS:
    case Types.SEND_SMS_CSV_SUCCESS:
      return { loading: false, success: true, batch: action.payload };
    case Types.SEND_SMS_FAIL:
    case Types.SEND_SMS_BULK_FAIL:
    case Types.SEND_SMS_CSV_FAIL:
      return { loading: false, error: action.payload };
    case Types.SEND_SMS_RESET:
      return {}; // Reset to initial state
    default:
      return state;
  }
};

export const MySmsReducer = (state = { smses: [] }, action) => {
  switch (action.type) {
    case Types.MY_SMS_REQUEST:
      return { loading: true, smses: state.smses };
    case Types.MY_SMS_SUCCESS:
      return { loading: false, smses: action.payload };
    case Types.MY_SMS_FAIL:
      return { loading: false, error: action.payload, smses: state.smses };
    default:
      return state;
  }
};

export const MySmsPagedReducer = (state = { smses: [] }, action) => {
  switch (action.type) {
    case Types.MY_SMS_PAGED_REQUEST:
      return { ...state, loading: true };
    
    case Types.MY_SMS_PAGED_SUCCESS:
      return {
        loading: false,
        smses: action.payload.content || action.payload,
        page: action.payload.number || 0,
        pages: action.payload.totalPages || 1,
        totalElements: action.payload.totalElements || (action.payload.content || action.payload).length,
      };
    
    case Types.MY_SMS_PAGED_FAIL:
      return { ...state, loading: false, error: action.payload };
    
    case Types.SEND_SMS_SUCCESS:
    case Types.SEND_SMS_BULK_SUCCESS:
    case Types.SEND_SMS_CSV_SUCCESS:
      const newSms = {
        id: action.payload.id,
        reference: action.payload.reference,
        sentAt: new Date().toISOString(),
        status: 'PENDING',
        ...action.payload
      };
      
      return {
        ...state,
        smses: [newSms, ...state.smses],
        totalElements: (state.totalElements || 0) + 1,
      };
    
    default:
      return state;
  }
};